import { createAsyncThunk } from '@reduxjs/toolkit';

import * as TenantApi from '@sophocles/api/tenant';
import TENANT_DEFAULTS from '@sophocles/features/tenant/defaults';

export const loadTenant = createAsyncThunk('tenant/load', async () => {
  try {
    return await TenantApi.fetchTenantInfo();
  } catch (e) {
    // /tenant/ unreachable — return the baked defaults so nav components
    // stay stable rather than flashing or showing empty values.
    return { ...TENANT_DEFAULTS };
  }
});
